module.exports = __webpack_public_path__ + "media/images/flavours/icon-fruit-a-coque_dark-4661eb50695fe13ba5a36b761a3e6d39.png";